import { useLocalisedCountries, useLocalisedGCCCountries } from '@tasama/utils';
import { useTranslation } from '@tasama/i18n';

export type { CountryOption } from '@tasama/utils';

export function useCountries() {
  const { t } = useTranslation('onboarding');
  const { data, isLoading, error } = useLocalisedCountries();

  return {
    countries: data ?? [],
    isLoading,
    error: error ? t('errors.failedToLoadCountries') : null,
  };
}

export function useGCCCountries() {
  const { t } = useTranslation('onboarding');
  const { data, isLoading, error } = useLocalisedGCCCountries();

  return {
    countries: data ?? [],
    isLoading,
    error: error ? t('errors.failedToLoadGccCountries') : null,
  };
}
